module.exports = __webpack_public_path__ + "static/iMac-4a29db609a1f83881db7438956cb88a4.svg";